import { useAsyncData } from '@repo/ui/dataProvider'
import { DropdownMenuItem } from '@repo/ui/dropdownMenu'
import { UserMinusIcon, UserPlusIcon } from 'lucide-react'

import { sudoStoreActions } from '@/store/actions'
import { useStoreDispatch } from '@/store/hooks'

export function OrganizationAccessManager({
  organizationId,
  myOrganizationIds,
  isMember,
}: {
  organizationId: string
  myOrganizationIds: string[]
  isMember: boolean
}) {
  const dispatch = useStoreDispatch()
  const {
    data: [user],
  } = useAsyncData([(state) => state.user.me])
  if (!user) return null

  const joinOrLeaveOrganization = (action: 'join' | 'leave', organizationId: string) => {
    const organizationIds =
      action === 'join'
        ? [...myOrganizationIds, organizationId] // add organizationId
        : myOrganizationIds.filter((id) => id !== organizationId) // remove organizationId
    void dispatch(
      sudoStoreActions.user.updateOrganizationsAccess({
        organizationIds,
        userId: user.id,
      }),
    )
  }
  return (
    <>
      {isMember ? (
        <DropdownMenuItem onClick={() => joinOrLeaveOrganization('leave', organizationId)}>
          <UserMinusIcon className="size-4" />
          Leave Organization
        </DropdownMenuItem>
      ) : (
        <DropdownMenuItem onClick={() => joinOrLeaveOrganization('join', organizationId)}>
          <UserPlusIcon className="size-4" />
          Join Organization
        </DropdownMenuItem>
      )}
    </>
  )
}
